(function () {
  const DEBUG = true;

  const VIEW_MAP = {
    "your-rewards": "view-your-rewards",
    "spendings": "view-spendings",
    "earnings": "view-earnings",
    "referrals-email": "view-referrals-email",
  };

  const ENTRY_SELECTOR = ".stamped-entry, .stamped-menu-entry";

  const log = (...a) => DEBUG && console.log("[stamped-entry]", ...a);
  const warn = (...a) => DEBUG && console.warn("[stamped-entry]", ...a);

  let isOpening = false;
  let lastPoints = null;
  let cartDiscountWatcher = null;
  let readyStateBound = false;

  function formatNumber(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function showStampedEntries() {
    const entries = document.querySelectorAll(ENTRY_SELECTOR);
    entries.forEach((el) => el.classList.add("is-ready"));
    log("showStampedEntries()", entries.length);
  }

  function hideStampedEntries() {
    const entries = document.querySelectorAll(ENTRY_SELECTOR);
    entries.forEach((el) => el.classList.remove("is-ready"));
    log("hideStampedEntries()", entries.length);
  }

  function hasPointsPlaceholderValue() {
    const el = document.querySelector("#stamped-rewards-points-placeholder");
    if (!el) return false;

    const text = (el.textContent || "").trim();
    return /[\d,]+\s*Points?/i.test(text) || /[\d,]+/.test(text);
  }

  function updateEntryVisibility() {
    if (hasPointsPlaceholderValue()) {
      showStampedEntries();
      return true;
    }

    hideStampedEntries();
    return false;
  }

  function startReadyWatcher() {
    if (readyStateBound) return;
    readyStateBound = true;

    let tries = 0;
    const maxTries = 100;

    const timer = setInterval(() => {
      tries += 1;

      const ready = updateEntryVisibility();
      if (ready) {
        clearInterval(timer);
        log("Stamped ready watcher resolved");
        return;
      }

      if (tries >= maxTries) {
        clearInterval(timer);
        log("Stamped ready watcher stopped (timeout)");
      }
    }, 300);
  }

  function applyPointsToAll() {
    if (!Number.isFinite(lastPoints)) return;

    const txt = formatNumber(lastPoints);
    const targets = document.querySelectorAll("[data-stamped-points]");

    targets.forEach((el) => {
      el.textContent = txt;
    });

    log("applyPointsToAll()", txt, "targets:", targets.length);
  }

  function setAllPoints(points) {
    if (!Number.isFinite(points)) return;
    lastPoints = points;
    applyPointsToAll();
  }

  function extractPointsFromPlaceholder() {
    const el = document.querySelector("#stamped-rewards-points-placeholder");
    if (!el) return null;

    const text = (el.textContent || "").trim();
    if (!text) return null;

    const m = text.match(/([\d,]+)/);
    if (!m) return null;

    const num = Number(m[1].replace(/,/g, ""));
    return Number.isFinite(num) ? num : null;
  }

  function extractPointsFromLauncher() {
    const el =
      document.querySelector(".stamped-rewards-header-main-points[data-points]") ||
      document.querySelector(".stamped-rewards-header-small-points[data-points]") ||
      document.querySelector('[data-name1="Points"][data-points]');

    if (el) {
      const raw = el.getAttribute("data-points");
      const num = Number(String(raw).replace(/,/g, ""));
      if (Number.isFinite(num)) return num;
    }

    const text = document.body.innerText || "";
    const m = text.match(/([\d,]+)\s*Points/i);
    if (!m) return null;

    const num = Number(m[1].replace(/,/g, ""));
    return Number.isFinite(num) ? num : null;
  }

  function extractPoints() {
    return extractPointsFromPlaceholder() ?? extractPointsFromLauncher();
  }

  function waitForStampedFn(timeoutMs = 8000) {
    return new Promise((resolve, reject) => {
      const start = Date.now();

      (function tick() {
        const ok =
          typeof window.StampedFn?.toggleRewardsModal === "function" &&
          typeof window.StampedFn?.loadLauncherView === "function";

        if (ok) return resolve(window.StampedFn);
        if (Date.now() - start > timeoutMs) {
          return reject(new Error("StampedFn timeout"));
        }

        setTimeout(tick, 120);
      })();
    });
  }

  function waitForLauncherDom(timeoutMs = 3000) {
    return new Promise((resolve, reject) => {
      const start = Date.now();

      const check = () => {
        const exists =
          document.querySelector("#stamped-launcher") ||
          document.querySelector(".stamped-launcher") ||
          document.querySelector(".stamped-modal") ||
          document.querySelector(".stamped-launcher-modal") ||
          document.querySelector(".stamped-rewards-header-container");

        if (exists) return resolve(true);
        if (Date.now() - start > timeoutMs) {
          return reject(new Error("Launcher DOM timeout"));
        }

        requestAnimationFrame(check);
      };

      check();
    });
  }

  function getCartRefreshUrl() {
    if (window.location.pathname !== "/cart") {
      return `${window.location.pathname}?section_id=cart-drawer`;
    }
    return window.location.pathname;
  }

  async function fetchCartHtmlDocument() {
    const url = getCartRefreshUrl();
    log("fetchCartHtmlDocument()", url);

    const response = await fetch(url, {
      credentials: "same-origin",
      headers: {
        Accept: "text/html",
      },
    });

    const responseText = await response.text();
    const parser = new DOMParser();
    return parser.parseFromString(responseText, "text/html");
  }

  function getCartSnapshot(doc) {
    const isCartPage = window.location.pathname === "/cart";

    if (isCartPage) {
      return doc.getElementById("js-contents")?.innerHTML?.trim() || "";
    }

    const footer =
      doc.getElementById("main-cart-footer")?.innerHTML?.trim() || "";

    const total =
      doc.querySelector(".cart-drawer-price-total")?.innerHTML?.trim() || "";

    const discounts =
      doc.querySelector(".cart-discounts")?.innerHTML?.trim() ||
      doc.querySelector(".cart-drawer__discounts")?.innerHTML?.trim() ||
      "";

    const totals =
      doc.querySelector(".totals")?.innerHTML?.trim() ||
      doc.querySelector(".cart__footer")?.innerHTML?.trim() ||
      doc.querySelector(".cart-drawer__footer")?.innerHTML?.trim() ||
      "";

    return JSON.stringify({
      footer,
      total,
      discounts,
      totals,
    });
  }

  function clearCartDiscountWatcher() {
    if (cartDiscountWatcher) {
      clearInterval(cartDiscountWatcher);
      cartDiscountWatcher = null;
      log("cart discount watcher cleared");
    }
  }

  async function refreshCartUIAfterDiscount() {
    log("refreshCartUIAfterDiscount() called");

    try {
      const isCartPage = window.location.pathname === "/cart";

      if (isCartPage) {
        log("cart page detected -> reload in 1200ms");
        setTimeout(() => {
          window.location.reload();
        }, 1200);
        return;
      }

      const html = await fetchCartHtmlDocument();

      const drawerSelectors = [
        "#main-cart-footer",
        ".cart-drawer-price-total",
        ".cart-drawer__footer",
        ".cart-drawer__discounts",
      ];

      drawerSelectors.forEach((selector) => {
        const newEl = html.querySelector(selector);
        const currentEl = document.querySelector(selector);

        if (newEl && currentEl) {
          currentEl.innerHTML = newEl.innerHTML;
          log(`cart drawer updated selector: ${selector}`);
        }
      });

      const rpCartIcon = html.querySelector("cart-icon-bubble");
      const cartIcon = document.querySelector("cart-icon-bubble");
      if (rpCartIcon && cartIcon) {
        cartIcon.innerHTML = rpCartIcon.innerHTML;
        log("cart-icon-bubble updated");
      }

      applyPointsToAll();
    } catch (error) {
      warn("refreshCartUIAfterDiscount failed:", error);
    }
  }

  async function startCartDiscountWatcher(options = {}) {
    const interval = options.interval ?? 800;
    const maxChecks = options.maxChecks ?? 50;

    clearCartDiscountWatcher();

    let checks = 0;
    let initialSnapshot = "";

    try {
      const initialDoc = await fetchCartHtmlDocument();
      initialSnapshot = getCartSnapshot(initialDoc);
      log("initial cart snapshot saved");
    } catch (error) {
      warn("failed to get initial cart snapshot:", error);
      return;
    }

    cartDiscountWatcher = setInterval(async () => {
      checks += 1;
      log(`discount watcher tick ${checks}/${maxChecks}`);

      try {
        const nextDoc = await fetchCartHtmlDocument();
        const nextSnapshot = getCartSnapshot(nextDoc);

        if (nextSnapshot !== initialSnapshot) {
          log("cart change detected");
          clearCartDiscountWatcher();

          await refreshCartUIAfterDiscount();
          return;
        }
      } catch (error) {
        warn("discount watcher fetch failed:", error);
      }

      if (checks >= maxChecks) {
        log("discount watcher stopped (timeout)");
        clearCartDiscountWatcher();
      }
    }, interval);
  }

  async function openStampedView(actionKey) {
    const viewId = VIEW_MAP[actionKey];
    if (!viewId) return warn("Unknown actionKey:", actionKey);

    if (isOpening) return log("Blocked: already opening");
    isOpening = true;

    try {
      const StampedFn = await waitForStampedFn();

      try {
        StampedFn.toggleRewardsModal();
        log("toggleRewardsModal()");
      } catch (e) {
        warn("toggleRewardsModal failed:", e);
      }

      try {
        await waitForLauncherDom();
      } catch (e) {
        warn(e);
      }

      try {
        StampedFn.loadLauncherView(viewId);
        log("loadLauncherView:", viewId);
      } catch (e) {
        warn("loadLauncherView failed:", e);
      }

      setTimeout(() => {
        const pts = extractPoints();
        log("sync points after open:", pts);
        if (pts != null) setAllPoints(pts);
      }, 250);

      if (actionKey === "spendings" || actionKey === "your-rewards") {
        startCartDiscountWatcher({
          interval: window.location.pathname === "/cart" ? 800 : 1500,
          maxChecks: window.location.pathname === "/cart" ? 50 : 30,
        });
      }
    } finally {
      setTimeout(() => {
        isOpening = false;
      }, 700);
    }
  }

  function bindDelegatedClick() {
    document.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-stamped-action]");
      if (!btn) return;

      e.preventDefault();
      const actionKey = btn.getAttribute("data-stamped-action");
      log("click:", actionKey);
      openStampedView(actionKey);
    });
  }

  function startObserver() {
    if (window.__stampedEntryObserverStarted) return;
    window.__stampedEntryObserverStarted = true;

    const obs = new MutationObserver((mutations) => {
      const pts = extractPoints();

      if (pts != null) {
        updateEntryVisibility();
      }

      if (pts != null && pts !== lastPoints) {
        log("points updated:", pts);
        setAllPoints(pts);
        return;
      }

      if (!Number.isFinite(lastPoints)) return;

      let shouldReapply = false;

      for (const m of mutations) {
        if (m.type === "childList" && m.addedNodes?.length) {
          for (const node of m.addedNodes) {
            if (node.nodeType !== 1) continue;

            if (
              node.matches?.("[data-stamped-points]") ||
              node.querySelector?.("[data-stamped-points]")
            ) {
              shouldReapply = true;
              break;
            }
          }
        }

        if (m.type === "characterData") {
          const parentEl = m.target?.parentElement;
          if (parentEl?.closest?.("[data-stamped-points]")) {
            shouldReapply = true;
          }
        }

        if (shouldReapply) break;
      }

      if (shouldReapply) {
        log("re-apply points triggered");
        applyPointsToAll();
      }
    });

    obs.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true,
    });

    const initial = extractPoints();
    log("initial points:", initial);

    if (initial != null) {
      setAllPoints(initial);
    }

    updateEntryVisibility();
    log("observer attached");
  }

  function init() {
    bindDelegatedClick();
    startObserver();
    startReadyWatcher();
    updateEntryVisibility();
    log("init done");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();